import { ActionTypes } from "../constants/action-types"

const initialState = {
    updateCategory:[]

}

export const UpdateCategory = (state=initialState, {type, payload})=>{
switch (type){
    case ActionTypes.UPDATE_CATEGORY: 
    return {...state, updateCategory: payload}
    default: return state
}

}

export default UpdateCategory